import { render, staticRenderFns } from "./ion-form-item.vue?vue&type=template&id=b922564e"
import script from "./ion-form-item.vue?vue&type=script&lang=js"
export * from "./ion-form-item.vue?vue&type=script&lang=js"
import style0 from "./ion-form-item.vue?vue&type=style&index=0&id=b922564e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports